import { render, staticRenderFns } from "./CabangPerdatin.vue?vue&type=template&id=44eddcb0"
import script from "./CabangPerdatin.vue?vue&type=script&lang=js"
export * from "./CabangPerdatin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports